import React, { Suspense } from "react"
import type { EditorProps } from "../Render/Variants/JobInput/Common/JSON/JSONEditor"

const Component = React.lazy(async () => {
    return import("../Render/Variants/JobInput/Common/JSON/JSONEditor")
})

export function JSONEditor<T>({
    fallback,
    ...props
}: EditorProps<T> & { fallback: JSX.Element }) {
    return (
        <Suspense fallback={fallback}>
            <Component {...(props as any)} />
        </Suspense>
    )
}
